import { combineReducers } from "redux";

import { initialScrapeTaskBatchStartsEntriesReducer } from "modules/InitialScrapeTaskBatchStarts/services/InitialScrapeTaskBatchStarts/reducer";

export const initialScrapeTaskBatchStartsReducer = combineReducers({ entries: initialScrapeTaskBatchStartsEntriesReducer });